import { Injectable } from '@angular/core';
import {map, Observable} from "rxjs";
import {iInputMitVersteckterBox, iNameEmail, iResult} from "../entity/interfaces/allgemein";
import {ApiService} from "./api.service";

@Injectable({
  providedIn: 'root'
})
export class JsonArrayDownloaderService {

  constructor(private api: ApiService) { }


  public jsonArrayDownload(jsonFile: String): Observable<iInputMitVersteckterBox[]|iNameEmail[]|string[]> {
    let adressEnd = '/symfony/jsonFileProvider'
        return this.api.get(adressEnd,{fileName:jsonFile})
      .pipe(map(resp => {
        if (resp.success) {
          return JSON.parse(resp.content);
          } else {
          return [];
        }
      }));
  }

}
